var map = {
	"./aiCanvas.svg": 77297,
	"./aiChart.svg": 28155,
	"./aiDocument.svg": 7694,
	"./aiDraw.svg": 14415,
	"./aiGauge.svg": 96394,
	"./aiList.svg": 86829,
	"./aiPest.svg": 10869,
	"./aiPicture.svg": 52189,
	"./aiPortrait.svg": 11792,
	"./aiQA.svg": 61987,
	"./aiStory.svg": 99524,
	"./aiSwot.svg": 45110,
	"./aiTable.svg": 90883,
	"./aiTimeline.svg": 16364,
	"./aiflowchart.svg": 22647,
	"./aimindmap.svg": 99933
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 30357;